import type { ApiMessage } from '@interfaces/message';

export type SearchResultKey = `${string}_${number}`;

export function getSearchResultKey(message: ApiMessage): SearchResultKey {
  const { conversation_id, id } = message;

  return `${conversation_id}_${id}`;
}

export function parseSearchResultKey(key: SearchResultKey) {
  const [conversationId, messageId] = key.split('_');

  return [Number(conversationId), Number(messageId)] as const;
}
